var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto p-2",staticStyle:{"max-width":"1200px"},attrs:{"dir":"ltr"}},[_c('b-card',{staticClass:"p-3",staticStyle:{"text-align":"left"},domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }